<template>
  <p class="text-h6 blue-grey--text text--darken-1">
      <slot></slot>
  </p>
</template>

<script>
export default {
  name:"ModuleHeader",
  props: [],
  data() {
    return {

    };
  },
  mounted: function () {
  },
  computed: {
  },
  methods: {
  },
};
</script>